// import {
//   FETCH_USERPROFILEDATA_FAILURE,
//   FETCH_USERPROFILEDATA_REQUEST,
//   FETCH_USERPROFILEDATA_SUCCESS,
// } from "./userProfileDataActionTypes";
// export const fetchUserProfileDataRequest = () => ({
//   type: FETCH_USERPROFILEDATA_REQUEST,
// });

// export const fetchUserProfileDataSuccess = (data, dataType) => ({
//   type: FETCH_USERPROFILEDATA_SUCCESS,
//   payload: { data, type: dataType },
// });

// export const fetchUserProfileDataFailure = (error) => ({
//   type: FETCH_USERPROFILEDATA_FAILURE,
//   payload: error,
// });

import {
  FETCH_USERPROFILEDATA_REQUEST,
  FETCH_USERPROFILEDATA_SUCCESS,
  FETCH_USERPROFILEDATA_FAILURE,
  CREATE_USERPROFILE_REQUEST,
  CREATE_USERPROFILE_SUCCESS,
  CREATE_USERPROFILE_FAILURE,
  UPDATE_USERPROFILE_REQUEST,
  UPDATE_USERPROFILE_SUCCESS,
  UPDATE_USERPROFILE_FAILURE,
  DELETE_USERPROFILE_REQUEST,
  DELETE_USERPROFILE_SUCCESS,
  DELETE_USERPROFILE_FAILURE,
} from "./userProfileDataActionTypes";

// FETCH
export const fetchUserProfileDataRequest = () => ({
  type: FETCH_USERPROFILEDATA_REQUEST,
});

export const fetchUserProfileDataSuccess = (data, dataType) => ({
  type: FETCH_USERPROFILEDATA_SUCCESS,
  payload: { data, type: dataType },
});

export const fetchUserProfileDataFailure = (error) => ({
  type: FETCH_USERPROFILEDATA_FAILURE,
  payload: error,
});

// CREATE
export const createUserProfileRequest = () => ({
  type: CREATE_USERPROFILE_REQUEST,
});

export const createUserProfileSuccess = (data, dataType) => ({
  type: CREATE_USERPROFILE_SUCCESS,
  payload: { data, type: dataType },
});

export const createUserProfileFailure = (error) => ({
  type: CREATE_USERPROFILE_FAILURE,
  payload: error,
});

// UPDATE
export const updateUserProfileRequest = () => ({
  type: UPDATE_USERPROFILE_REQUEST,
});

export const updateUserProfileSuccess = (data, dataType) => ({
  type: UPDATE_USERPROFILE_SUCCESS,
  payload: { data, type: dataType },
});

export const updateUserProfileFailure = (error) => ({
  type: UPDATE_USERPROFILE_FAILURE,
  payload: error,
});

// DELETE
export const deleteUserProfileRequest = () => ({
  type: DELETE_USERPROFILE_REQUEST,
});

export const deleteUserProfileSuccess = (data, dataType) => ({
  type: DELETE_USERPROFILE_SUCCESS,
  payload: { data, type: dataType },
});

export const deleteUserProfileFailure = (error) => ({
  type: DELETE_USERPROFILE_FAILURE,
  payload: error,
});
